// JWT login/signup for the refactored Tomahawk.
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, setSession } from "../lib/api";

export default function AuthLogin() {
  const [mode, setMode] = useState("login");
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      const fn = mode === "login" ? api.login : api.signup;
      const r = await fn(form);
      setSession(r.access_token, r.client_id, r.name);
      navigate("/personas");
    } catch (e) { setErr(String(e.message)); } finally { setBusy(false); }
  };

  const inp = "w-full rounded-md bg-neutral-800 border border-neutral-700 px-3 py-2 text-sm mb-3";

  return (
    <div className="min-h-screen flex items-center justify-center bg-neutral-950 text-neutral-100">
      <div className="w-full max-w-sm px-8 py-10 rounded-xl border border-neutral-800 bg-neutral-900/60">
        <div className="text-2xl font-bold tracking-tight">Tomahawk<span className="text-red-600">.</span></div>
        <p className="mt-1 text-xs text-neutral-500">Inteligência territorial de aquisição</p>
        <form onSubmit={submit} className="mt-6">
          {mode === "signup" && (
            <input className={inp} placeholder="Nome" value={form.name} required
              onChange={(e) => setForm({ ...form, name: e.target.value })} />
          )}
          <input className={inp} type="email" placeholder="E-mail" value={form.email} required
            onChange={(e) => setForm({ ...form, email: e.target.value })} />
          <input className={inp} type="password" placeholder="Senha" value={form.password} required
            onChange={(e) => setForm({ ...form, password: e.target.value })} />
          {err && <div className="text-red-400 text-xs mb-3">{err}</div>}
          <button className="w-full rounded-md bg-red-600 hover:bg-red-500 px-4 py-2 text-sm font-medium disabled:opacity-50" disabled={busy}>
            {busy ? "…" : mode === "login" ? "Entrar" : "Criar conta"}
          </button>
        </form>
        <button className="mt-4 text-xs text-neutral-500 hover:text-neutral-300"
          onClick={() => setMode(mode === "login" ? "signup" : "login")}>
          {mode === "login" ? "Não tem conta? Cadastre-se" : "Já tem conta? Entrar"}
        </button>
      </div>
    </div>
  );
}
